import React, { useState, useEffect, useRef, useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./Home.css";
import styles from './AskMe.module.css';
import uploadBtnStyles from '../UI/UploadPasteButton.module.css';
import AuthSideMenu from "../UI/AuthSideMenu/AuthSideMenu";
import { Grid } from "@mui/material";
import StopIcon from "@mui/icons-material/Stop";
import MicIcon from '@mui/icons-material/Mic';
import CloseIcon from "@mui/icons-material/Close";
import CancelIcon from '@mui/icons-material/Cancel';
import AddIcon from '@mui/icons-material/Add';
import { TbScreenshot } from "react-icons/tb";
import AuthInput from "../UI/Input/AuthInputs";
import { ButtonSubmitBlack, ButtonTransparentSquare } from "../UI/Buttons/Buttons"
import { useSelector, useDispatch } from "react-redux";
import { setMessage, deleteLastMessage, setMessages, setAllMessagesArray, setFetching } from "../../redux/states";
import { Assistant, User, ScrollToBottom } from "../UI/ChatBoxes/ChatBoxes";
import { Oval } from 'react-loader-spinner'
import { BiMenuAltLeft } from "react-icons/bi";
import { BiMenuAltRight } from "react-icons/bi";
import { GrSend } from "react-icons/gr";
import { FaRobot, FaBolt } from "react-icons/fa";
import { LineWave, Vortex } from 'react-loader-spinner'
import axios from "axios";
import { checkAuthenticatedUser, isIOSStandalonePWA } from "../../utils/client-functions";
import { useErrorSetter, useSuccessSetter, useInfoSetter } from '../../hooks/useUiMessages';
import ResumePricing from "../Pricing/ResumePricing";
import analyticsTracker from "../../utils/analytics"; // legacy for compatibility (will be phased out)
import holisticAnalytics from "../../utils/holisticAnalytics";
import { useConfirm } from "material-ui-confirm";
import styledSC, { keyframes } from 'styled-components';

const bounce = keyframes`
  0%, 80%, 100% { transform: scale(0); opacity: 0.3; }
  40% { transform: scale(1); opacity: 1; }
`;

const shimmer = keyframes`
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
`;

const ThinkingContainer = styledSC.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 4px 8px;
`;

const Dot = styledSC.div`
  width: 6px;
  height: 6px;
  background-color: #3E8F93;
  border-radius: 50%;
  display: inline-block;
  animation: ${bounce} 1.4s infinite ease-in-out both;
  &:nth-child(1) { animation-delay: -0.32s; }
  &:nth-child(2) { animation-delay: -0.16s; }
`;

const ThinkingText = styledSC.span`
  font-size: 0.85rem;
  font-weight: 600;
  letter-spacing: 0.05em;
  background: linear-gradient(90deg, #3E8F93, #0d3d40, #3E8F93);
  background-size: 200% auto;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: ${shimmer} 3s linear infinite;
  text-transform: uppercase;
`;

const screenWidth = window.innerWidth


const AskMe = () => {
  const { messages, allMessagesArray, user } = useSelector((state) => state.stateData);
  const dispatch = useDispatch();
  const confirmDialog = useConfirm();
  const chatBoxRef = useRef(null);
  const prevScrollHeight = useRef(null);
  const navigate = useNavigate();
  const isAuth = localStorage?.getItem("token");
  const now = new Date().getTime();
  const countItemJson = localStorage?.getItem("oats_3297");
  const item = JSON.parse(countItemJson);
  const useCount = item ? item.cu78tgGgivhcountJVGIbGguguGhgh : 0;
  const expiration = item?.UYiygc768FYexpUVIirationHi87f86DCCC;
  
  const [tutorContext, setTutorContext] = useState(null);

  useEffect(() => {
    const raw = sessionStorage.getItem("bubbleai_tutor_context");
    if (raw) {
      try {
        const parsed = JSON.parse(raw);
        setTutorContext(parsed);
      } catch (e) {
        console.error("Failed to parse tutor context", e);
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCancelTutor = () => {
    confirmDialog({
      title: 'Terminate AI Tutor?',
      description: 'Are you sure you want to terminate the AI Tutor session? This context will be removed from your current chat session.',
      confirmationText: 'Terminate',
      cancellationText: 'Stay',
      confirmationButtonProps: { color: 'error' }
    }).then(() => {
      sessionStorage.removeItem("bubbleai_tutor_context");
      setTutorContext(null);
    }).catch(() => {});
  };

  // Initialize analytics
  const analytics = holisticAnalytics;

  const [authMenuOpen, setAuthMenuOpen] = useState(false)
  const [askMeVal, setAskMeVal] = useState("")
  const [recording, setRecording] = useState(false);
  const [audioBlob, setAudioBlob] = useState(null);
  // Image paste/upload states (multi-image up to 5)
  const [imagePreviews, setImagePreviews] = useState([]); // array of object URLs
  const [imageFiles, setImageFiles] = useState([]); // array of File/Blob
  const [inputFocused] = useState(false);
  const [mediaRecorder, setMediaRecorder] = useState(null);
  const [audioTranscribed, setAudioTranscribed] = useState(false)
  const [transcribing, setTranscribing] = useState(false)
  const [prepCalled, setPrepCalled] = useState(false)
  const [isTyping, setIsTyping] = useState(false);
  const [askPricingOpen, setAskPricingOpen] = useState(false);
  const [interviewLoading, setInterviewLoading] = useState(false);
    // State for batch loading and scroll button
  const [displayedMessages, setDisplayedMessages] = useState([]);
  // const [batchSize] = useState(10); // (unused after redesign)
  const [isLoadingMore] = useState(false);
  const [showScrollButton, setShowScrollButton] = useState(false);

  // Analytics tracking - add session header for all requests
  const sessionId = holisticAnalytics.sessionId;
  // One-shot guard to prevent multiple interview generation calls/events per session
  const interviewGuardRef = useRef(false);
  const interviewGuardKey = useMemo(() => `askme_interview_guard_${sessionId}`, [sessionId]);
  const sessionCreateGuardRef = useRef(false);
  const sessionCreateKey = useMemo(() => `askme_interview_session_guard_${sessionId}`, [sessionId]);
  
  // Set up axios interceptor to include session ID in all requests
  // Initialization effect (single run) – previously depended on messages.length causing race re-triggers
  useEffect(() => {
    const interceptor = axios.interceptors.request.use((config) => {
      config.headers['x-session-id'] = sessionId;
      return config;
    });

    return () => {
      axios.interceptors.request.eject(interceptor);
    };
  }, [sessionId]);

  // Analytics: Track input abandonment
  useEffect(() => {
    let timeout;
    if (askMeVal.length > 5) { // Only track if user typed something meaningful
      timeout = setTimeout(() => {
        if (askMeVal.length > 0) {
          holisticAnalytics.track('input_abandoned', { messageLength: askMeVal.length });
        }
      }, 30000); // 30 seconds of inactivity
    }
    
    return () => {
      if (timeout) clearTimeout(timeout);
    };
  }, [askMeVal]);




  // Deprecated coverLetterPrompt localStorage key (kept comment for reference)

  const errorSetter = useErrorSetter();
  const successSetter = useSuccessSetter();
  const infoSetter = useInfoSetter();

  const askMeErrorObj = {
    role: 'assistant',
    content:  "I am currently throttling requests, try again in a moment"
  }

  useEffect(() => {
    // Analytics: Track session start
    const entryPoint = document.referrer ? 'referral' : 'direct';
    holisticAnalytics.track('session_start', { entryPoint });

    // Track session end when component unmounts
    return () => {
      analytics.track('session_end');
    };
  }, [analytics]);

  // useEffect(() => {
  //   if (woot) {
  //     localStorage?.removeItem('woot')
  //     window.location.reload()
  //   }
  // }, [woot]);

  // Clipboard paste handler for images + file input handling
  useEffect(() => {
    const handlePaste = (e) => {
      try {
        const items = e.clipboardData && e.clipboardData.items;
        if (!items) return;
        for (let i = 0; i < items.length; i++) {
          const item = items[i];
          if (item.type.indexOf('image') !== -1) {
            const blob = item.getAsFile();
            if (blob) {
              // validate size (max 10MB)
              const maxBytes = 10 * 1024 * 1024;
              if (blob.size > maxBytes) {
                errorSetter('Image larger than 10MB');
                return;
              }
              // enforce max 5 total
              if (imageFiles.length >= 5) {
                errorSetter('Maximum 5 images allowed');
                return;
              }
              const url = URL.createObjectURL(blob);
              setImagePreviews(prev => [...prev, url].slice(0,5));
              setImageFiles(prev => [...prev, blob].slice(0,5));
              // do not break; allow multiple pasted items if any
            }
          }
        }
      } catch (err) {
        // ignore
      }
    };

    window.addEventListener('paste', handlePaste);

    return () => {
      window.removeEventListener('paste', handlePaste);
      // cleanup object URLs
      imagePreviews.forEach(u => { try { URL.revokeObjectURL(u); } catch(_) {} });
    };
  }, [imagePreviews, imageFiles.length, errorSetter]);


  //fetch messages, interview prep, follow up email, etc for auth user
  useEffect(() => {

    const prepInStorage = localStorage?.getItem("HFLHASIGFWFIVQJKVKJJBJKVSHDVHVIVIVIVHVhvhjavcdhuchch_Int_Prep-fu-em_aghgxtdRWYRDWY") 

    const populateMessages = async () => {
      if (isAuth) {
        //only try this if isAuth present in local Storage, meaning user had previously logged into browser
        try {
          //must await
          await checkAuthenticatedUser()
        } catch (error) {
          return navigate("/popin");      
        }

        try {
          const headers = {
            "x-access-token": isAuth,
          };
          const response = await axios.get("/user/messages", { headers });
          const messagesArrayofArray = response.data.messages;
          const threadsMeta = response.data.threadsMeta || [];
          // Attach meta to each message array by index for downstream menu (we keep Redux shape same)
          const decorated = messagesArrayofArray.map((arr, idx) => {
            const meta = threadsMeta[idx] || {};
            // Add a non-enumerable meta property to avoid UI iteration issues
            try { Object.defineProperty(arr, '__meta', { value: meta, enumerable: false, configurable: false }); } catch(_) {}
            return arr;
          });
          dispatch(setAllMessagesArray(decorated));
          if (decorated.length > 0) dispatch(setMessages(decorated[decorated.length - 1]));
        } catch (error) {
          errorSetter("Reload page to fetch data");
        }
      } 
    };
    

    const prepFunc = async (params) => {
      // Guard: ensure interview generation triggers only once per session
      if (interviewGuardRef.current || sessionStorage.getItem(interviewGuardKey) === 'locked') {
        return;
      }
      // Lock immediately to avoid rapid double-invocations
      interviewGuardRef.current = true;
      try { sessionStorage.setItem(interviewGuardKey, 'locked'); } catch(_) {}
      const newMsg = {
        content: params
      };
      //Dispatch with empty content to enable thinking algo
      const emptyMsg = {
        role: "assistant",
        content: "",
      };
      // dispatch(setMessage(newMsg));
      dispatch(setMessage(emptyMsg));
      setInterviewLoading(true);
      // Analytics: interview/follow-up request initiated (client-side) – first and only time per session
      try {
        const lower = String(params || '').toLowerCase();
        const isFollow = lower.includes('follow-up email') || lower.includes('followup email') || lower.includes('follow up email');
        holisticAnalytics.track(isFollow ? 'interview.followup.requested' : 'interview.mock.requested', { featureUsed: 'service_redirect', eventData: { source: 'askme.prepFunc' }});
      } catch(_){ }
      try {
        let response = await axios.post("/int-em", newMsg, {
          headers: {
            "x-access-token": isAuth,
          },
        });

        // Backend now returns { status:'processing', jobId } or quota/errors
        if (response?.data?.status === 'processing' && response?.data?.jobId) {
          // Poll job status every 30s until completion
          const jobId = response.data.jobId;
          const poll = async () => {
            try {
              const jr = await axios.get(`/jobs/interview/${jobId}`, { headers: { 'x-access-token': isAuth } });
              if (jr?.data?.status === 'done' && jr?.data?.result) {
                dispatch(deleteLastMessage());
                dispatch(setMessage(jr.data.result));
                setInterviewLoading(false);
                return true;
              }
              if (jr?.data?.status === 'failed') {
                dispatch(deleteLastMessage());
                dispatch(setMessage({ role:'assistant', content: 'Interview generation failed. Try again.' }));
                setInterviewLoading(false);
                return true;
              }
              return false;
            } catch(_) { return false; }
          };
          // initial quick poll, then 30s cadence
          let done = await poll();
          if (!done) {
            const interval = setInterval(async () => {
              const finished = await poll();
              if (finished) clearInterval(interval);
            }, 3000);
          }
          return;
        }

        // Backend may return quota as a 200 with status field
        if (response?.data?.status === 'quota') {
          const statusCode = response.status;
          if (statusCode === 403 && response.data.openPricing) {
            // Analytics: Track pricing view from quota hit
            holisticAnalytics.track('subscription.pricing_viewed', { viewedPricing: true });
            setAskPricingOpen(true);
            dispatch(deleteLastMessage());
            errorSetter(response.data.message || 'Quota reached. Upgrade to continue.');
            dispatch(setMessage({ role: 'assistant', content: response.data.message || 'Quota reached. Upgrade to continue.' }));
            setInterviewLoading(false);
            return;
          }
          if (statusCode === 429) {
            dispatch(deleteLastMessage());
            errorSetter(response.data.message || 'Quota reached. Upgrade to continue.');
            dispatch(setMessage({ role: 'assistant', content: response.data.message || 'Daily quota reached. Try again tomorrow.' }));
            setInterviewLoading(false);
            return;
          }
          dispatch(deleteLastMessage());
          errorSetter(response.data.message || 'Quota reached.');
          dispatch(setMessage({ role: 'assistant', content: response.data.message || 'Quota reached.' }));
          setInterviewLoading(false);
          return;
        }

        //save ai response for auth user
        dispatch(deleteLastMessage());
        dispatch(setMessage(response.data));
        setInterviewLoading(false);

        // Analytics: success generated (client confirmation) – first and only time per session
        try {
          const lower = String(params || '').toLowerCase();
          const isFollow = lower.includes('follow-up email') || lower.includes('followup email') || lower.includes('follow up email');
          holisticAnalytics.track(isFollow ? 'interview.followup.generated' : 'interview.mock.generated', { featureUsed: 'service_redirect', eventData: { source: 'askme.prepFunc', length: response?.data?.content?.length || 0 }});
        } catch(_){ }

      } catch (error) {
        // If axios error contains quota payload
        const resp = error?.response;
        if (resp && resp.data && resp.data.status === 'quota') {
          const statusCode = resp.status;
          if (statusCode === 403 && resp.data.openPricing) {
            // Analytics: Track pricing view from error response
            holisticAnalytics.track('subscription.pricing_viewed', { viewedPricing: true });
            setAskPricingOpen(true);
            errorSetter(resp.data.message || 'Quota reached. Upgrade to continue.');
            dispatch(deleteLastMessage());
            dispatch(setMessage({ role: 'assistant', content: resp.data.message || 'Quota reached. Upgrade to continue.' }));
            setInterviewLoading(false);
            return;
          }
          if (statusCode === 429) {
            errorSetter(resp.data.message || 'Quota reached. Upgrade to continue.');
            errorSetter(resp.data.message || 'Quota reached. Upgrade to continue.');
            dispatch(deleteLastMessage());
            dispatch(setMessage({ role: 'assistant', content: resp.data.message || 'Daily quota reached. Try again tomorrow.' }));
            setInterviewLoading(false);
            return;
          }
          dispatch(deleteLastMessage());
          errorSetter(resp.data.message || 'Quota reached.');
          dispatch(setMessage({ role: 'assistant', content: resp.data.message || 'Quota reached.' }));
          setInterviewLoading(false);
          return;
        }

        dispatch(deleteLastMessage());
        dispatch(setMessage(askMeErrorObj));
        setInterviewLoading(false);
  // Analytics: failed generation – still only once per session because guard is locked
        try {
          const lower = String(params || '').toLowerCase();
          const isFollow = lower.includes('follow-up email') || lower.includes('followup email') || lower.includes('follow up email');
          holisticAnalytics.track(isFollow ? 'interview.followup.failed' : 'interview.mock.failed', { featureUsed: 'service_redirect', eventData: { source: 'askme.prepFunc', error: error?.message }});
        } catch(_){ }
      }
    }


    const handleTailoredInterviewPrep = async (param) => {
      if (prepInStorage) {
        infoSetter("Generating Interview, Do NOT Reload...")
        // Always create a fresh session then run prepFunc so quota responses are handled reliably
        const emptyArr = [];
        try {
          // Prevent duplicate session creation via in-page or quick-double triggers
          if (!sessionCreateGuardRef.current && sessionStorage.getItem(sessionCreateKey) !== 'locked') {
            sessionCreateGuardRef.current = true;
            try { sessionStorage.setItem(sessionCreateKey, 'locked'); } catch(_) {}
            // If the latest session is already empty, reuse it instead of creating a new one
            const last = Array.isArray(allMessagesArray) && allMessagesArray.length > 0 ? allMessagesArray[allMessagesArray.length - 1] : null;
            const hasEmptyLatest = Array.isArray(last) && last.length === 0;
            if (!hasEmptyLatest) {
              await axios.post("/create-new-askme-session", emptyArr, {
                headers: { "x-access-token": isAuth },
              });
            }
          }
          // After creation, fetch all threads
          try {
            const m = await axios.get('/user/messages', { headers: { "x-access-token": isAuth } });
            const arr = Array.isArray(m?.data?.messages) ? m.data.messages : [];
            const meta = m?.data?.threadsMeta || [];
            const decorated = arr.map((a,i) => { try { Object.defineProperty(a,'__meta',{ value: meta[i]||{}, enumerable:false}); } catch(_){} return a; });
            dispatch(setAllMessagesArray(decorated));
            if (decorated.length > 0) dispatch(setMessages(decorated[decorated.length - 1]));
          } catch(_) {}
          await prepFunc(param);
          localStorage?.removeItem("HFLHASIGFWFIVQJKVKJJBJKVSHDVHVIVIVIVHVhvhjavcdhuchch_Int_Prep-fu-em_aghgxtdRWYRDWY");
          
        } catch (error) {
          errorSetter("Please try again");
          try { holisticAnalytics.track('interview.mock.failed', { featureUsed: 'service_redirect', eventData: { source: 'askme.handleTailoredInterviewPrep', error: error?.message }}); } catch(_){ }
          return;
        } 
      }

    }

    if (!prepCalled) {
      populateMessages()
      .then(async () => {
        setPrepCalled(true)
        await handleTailoredInterviewPrep(prepInStorage)
  try { holisticAnalytics.track('interview.entry', { featureUsed: 'service_redirect', eventData: { source: 'askme.autoPrepStart' }}); } catch(_){ }
        localStorage.removeItem("HFLHASIGFWFIVQJKVKJJBJKVSHDVHVIVIVIVHVhvhjavcdhuchch_Int_Prep-fu-em_aghgxtdRWYRDWY")
      })
      .catch((error) => {
        errorSetter("Try again")
        localStorage.removeItem("HFLHASIGFWFIVQJKVKJJBJKVSHDVHVIVIVIVHVhvhjavcdhuchch_Int_Prep-fu-em_aghgxtdRWYRDWY")
      })
      
    }

  // eslint-disable-next-line react-hooks/exhaustive-deps -- intentionally restricting deps to avoid re-triggering auto interview prep logic
  }, [prepCalled]);

  // Scroll and message display logic
  const scrollToBottom = () => {
    if (chatBoxRef.current) {
      chatBoxRef.current.scrollTop = chatBoxRef.current.scrollHeight;
    }
  };

  const handleScroll = () => {
    if (chatBoxRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = chatBoxRef.current;
      const isScrolledUp = scrollHeight - scrollTop - clientHeight > 300;
      setShowScrollButton(isScrolledUp);
      
      // if (scrollTop < 100 && messages.length > displayedMessages.length && !isLoadingMore) {
      //   loadMoreMessages();
      // }
    }
  };

  // const loadMoreMessages = () => {
  //   if (chatBoxRef.current) {
  //     prevScrollHeight.current = chatBoxRef.current.scrollHeight - chatBoxRef.current.scrollTop;
  //   }
    
  //   setIsLoadingMore(true);
    
  //   setTimeout(() => {
  //     const currentLength = displayedMessages.length;
  //     const remainingMessages = messages.length - currentLength;
      
  //     if (remainingMessages > 0) {
  //       const loadCount = Math.min(batchSize, remainingMessages);
  //       const startIndex = Math.max(0, messages.length - currentLength - loadCount);
  //       const endIndex = startIndex + loadCount;
        
  //       const newBatch = messages.slice(startIndex, endIndex);
  //       setDisplayedMessages(prev => [...newBatch, ...prev]);
  //     }
      
  //     setIsLoadingMore(false);
  //   }, 300);
  // };

  // Initialize displayed messages
  useEffect(() => {
    if (messages.length > 0) {
      setDisplayedMessages(messages);
    } else {
      setDisplayedMessages([]);
    }
  }, [messages]);

  // Scroll event listener
  useEffect(() => {
    const chatBoxElement = chatBoxRef.current;
    if (chatBoxElement) {
      chatBoxElement.addEventListener('scroll', handleScroll);
      return () => chatBoxElement.removeEventListener('scroll', handleScroll);
    }
  }, [messages, displayedMessages.length]);
  
  // Scroll position management
  useEffect(() => {
    if (chatBoxRef.current && prevScrollHeight.current && !isLoadingMore) {
      const newScrollHeight = chatBoxRef.current.scrollHeight;
      chatBoxRef.current.scrollTop = newScrollHeight - prevScrollHeight.current;
      prevScrollHeight.current = null;
    }
  }, [displayedMessages, isLoadingMore]);

  // Auto-scroll for new messages
  useEffect(() => {
    if (messages.length > displayedMessages.length && !isLoadingMore) {
      scrollToBottom();
    }
  }, [messages.length, displayedMessages.length, isLoadingMore]);

  // Initial scroll
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      scrollToBottom();
    }, 100);
    return () => clearTimeout(timeoutId);
  }, []);

  //check and remove unauth user's expired use count for ask me anything
  useEffect(() => {
    if (expiration < now) {
      localStorage?.removeItem("oats_3297");
    }
  }, [expiration, now])


  useEffect(() => {
    if (audioTranscribed) {
      handleAskMeAnything();
      setAudioTranscribed(false)
      setTranscribing(false)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps -- handleAskMeAnything stable enough; avoid re-registering
  }, [audioTranscribed]);
  

  const renderLineWaves = () => {
    const lineWaves = [];
    const count = screenWidth > 900 ? 10 : 8
    for (let i = 0; i < count; i++) {
      lineWaves.push(
        <LineWave
          key={i}
          visible={true}
          height="40"
          width="100%"
          color="#3E8F93"
          ariaLabel="line-wave-loading"
        />
      );
    }
    return lineWaves;
  };

  // Message rendering
  const chatExchange = displayedMessages.map((message, index) => {
    
    const isAssistant = message.role === "assistant";
    let contentTrim = message.content.trim();
    const assistantMessage = message.content;
    
    const showTyping = index === displayedMessages.length - 1 && 
                      isAssistant && 
                      contentTrim === "" && 
                      isTyping;

    const content = isAssistant ? (
      <Assistant contentTrim={contentTrim === ""}>
        {showTyping ? (
          <ThinkingContainer>
            <ThinkingText>Thinking</ThinkingText>
            <div style={{ display: 'flex', gap: '4px' }}>
              <Dot />
              <Dot />
              <Dot />
            </div>
          </ThinkingContainer>
        ) : (
          assistantMessage
        )}
      </Assistant>
    ) : (
      <User>{message.content}</User>
    );
    return <div key={index}>{content}</div>;
  });


  const handleAskMeAnything = async () => {

    if (askMeVal === "") {
      errorSetter("Empty question detected")
      return
    }
    
    // Analytics: Track message being sent
    holisticAnalytics.track('message_sent', { featureUsed: imageFiles.length > 0 ? 'image' : 'text', interactionType: imageFiles.length > 0 ? 'image' : 'text', messageLength: askMeVal.length });

    setIsTyping(true);

    const newMessage = {
      role: "user",
      content: askMeVal,
    };

    //Dispatch with empty content to enable thinking algo
    const emptyMessage = {
      role: "assistant",
      content: "",
    };
    dispatch(setMessage(newMessage));
    dispatch(setMessage(emptyMessage));
    const lastFiveMessages = [...messages.slice(-4), newMessage]; 
    const promptForBackend = {
      lastFiveMessages
    }

  // If an image is attached, include it in the /askme request as multipart/form-data
  if (isAuth) {
    //save authenticated user message
    setAskMeVal("");
    try {
      let response;
      if (imageFiles.length > 0) {
        const totalSize = imageFiles.reduce((acc,f)=>acc + (f?.size||0), 0);
        analytics.trackImageEvent('image_uploaded', { imageCount: imageFiles.length, totalSize });
        const form = new FormData();
        imageFiles.forEach(f => form.append('images', f));
        // send the prompt as a JSON string so server can parse it from multipart
        form.append('lastFiveMessages', JSON.stringify(promptForBackend.lastFiveMessages || promptForBackend));
        if (tutorContext) form.append('tutorContext', JSON.stringify(tutorContext));
        const headers = { 'Content-Type': 'multipart/form-data', 'x-access-token': isAuth, 'x-session-id': analytics.sessionId };
        // Clear preview immediately after preparing the upload so UI resets while request runs
        clearAllImagePreviews();
        response = await axios.post('/askme', form, { headers });
      } else {
        response = await axios.post("/askme", { ...promptForBackend, tutorContext }, {
          headers: {
            "x-access-token": isAuth,
            "x-session-id": analytics.sessionId
          },
        });
      }
      //save ai response for auth user
      dispatch(deleteLastMessage());
      dispatch(setMessage(response.data));
      // remove image preview after prompt sent
      clearAllImagePreviews();
      setIsTyping(false);
      localStorage?.removeItem("UF76rOUFfVA6A87AJjhaf6bvaIYI9GHJFJHfgag0HFHJFAfgaHGA")
    } catch (error) {
      dispatch(deleteLastMessage());
      setIsTyping(false);
      if (error?.response?.data?.openPricing) {
        window.dispatchEvent(new CustomEvent('openExamPricing'));
        dispatch(setMessage({
          role: "assistant",
          content: error.response.data.message || "You have reached your AI Tutor limit for today. Please upgrade for unlimited access."
        }));
      } else {
        dispatch(setMessage(askMeErrorObj));
      }
    }
  } else {
      //prevent overuse when not logged in
      const useIndicator = {
        cu78tgGgivhcountJVGIbGguguGhgh: useCount + 1,
        UYiygc768FYexpUVIirationHi87f86DCCC: now + 24 * 60 * 60 * 1000, //current time + 24hr in milliseconds
      };
      const useIndicatorJson = JSON.stringify(useIndicator);

      if (useCount > 2) {
        //set user message
        const overUseMessage = {
          role: "assistant",
          content: "You have used up your unregistered user interactions for the day, kindly <a href='/join-bubble'>Register here</a> or <a href='/popin'>Log in</a> to enjoy more for FREE",
        };
        
        // Analytics: Track quota hit and auth prompt
        holisticAnalytics.track('quota_hit', { hitQuotaLimit: true });
        holisticAnalytics.track('funnel.login_prompt_shown', { promptedToLogin: true });

        dispatch(deleteLastMessage());
        dispatch(setMessage(overUseMessage));
        setAskMeVal("");
        setIsTyping(false);
        return
      } else {
        //THIS BLOCK WORKS FOR unauthenticated users below 3 usage within the day
        setAskMeVal("");

        try {
          let response;
          if (imageFiles.length > 0) {
            const totalSize = imageFiles.reduce((acc,f)=>acc + (f?.size||0), 0);
            analytics.trackImageEvent('image_uploaded', { imageCount: imageFiles.length, totalSize });
            const form = new FormData();
            imageFiles.forEach(f => form.append('images', f));
            form.append('lastFiveMessages', JSON.stringify(promptForBackend.lastFiveMessages || promptForBackend));
            if (tutorContext) form.append('tutorContext', JSON.stringify(tutorContext));
            // Clear preview immediately after preparing the upload so UI resets while request runs
            clearAllImagePreviews();
            response = await axios.post('/askme', form, { 
              headers: { 
                'Content-Type': 'multipart/form-data',
                'x-session-id': analytics.sessionId
              } 
            });
          } else {
            response = await axios.post("/askme", { ...promptForBackend, tutorContext }, {
              headers: {
                'x-session-id': analytics.sessionId
              }
            });
          }
          dispatch(deleteLastMessage());
          dispatch(setMessage(response.data));
          // remove image preview after prompt sent
          clearAllImagePreviews();
          localStorage.setItem("oats_3297", useIndicatorJson);
          setIsTyping(false);
        } catch (error) {
          dispatch(deleteLastMessage());
          dispatch(setMessage(askMeErrorObj));
        }
      }
    }
  };

  
  const handleRecordAudio = () => {
    if (!recording) {
      // ANALYTICS: Track voice recording start
      analyticsTracker.trackVoiceInteraction();
      
      if (navigator.mediaDevices?.getUserMedia) {
        navigator.mediaDevices.getUserMedia({ audio: true })
          .then(stream => {
            const mediaRecorder = new MediaRecorder(stream);
            const audioChunks = [];
            
            mediaRecorder.ondataavailable = (event) => {
              audioChunks.push(event.data);
            };
            
            mediaRecorder.onstop = () => {
              const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
              // iOS typically records in AAC (m4a), others default to webm/mp3
              const blobType = isIOS ? 'audio/mp4' : 'audio/webm'; // Use 'audio/mp4' for AAC

              const audioBlob = new Blob(audioChunks, { type: blobType });
              setAudioBlob(audioBlob);
            };
            
            mediaRecorder.start();
            setRecording(true);
            setMediaRecorder(mediaRecorder);
          })
          .catch(error => {
            // Analytics: Track voice recording error
            analyticsTracker.trackError('voice_recording_failed', error.message);
            errorSetter('Microphone access denied');
          });
      } else {
        analytics.trackVoiceEvent('recording_not_supported');
        errorSetter('Audio recording not supported');
      }
    } else {
      analytics.trackVoiceEvent('recording_stopped');
      if (mediaRecorder) mediaRecorder.stop();
      setRecording(false);
    }
  };
  

  const handleSendAudio = async () => {
    if (!audioBlob || !mediaRecorder || mediaRecorder.state !== 'inactive') {
      return errorSetter('No audio to send');
    }
  
    analytics.trackVoiceEvent('audio_submitted', { audioSize: audioBlob.size });

    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    const fileName = isIOS ? 'audio.m4a' : 'audio.webm'; // .m4a for iOS, .webm for others

    const formData = new FormData();
    formData.append('audio', audioBlob, fileName);
  
    setAudioBlob(null);
    setTranscribing(true);
    setIsTyping(true);
  
    try {
      const response = await axios.post('/transcript/transcribe-askme', formData, {
        headers: {
          'Content-Type': 'multipart/form-data', // Required for file uploads
          'x-session-id': analytics.sessionId
        },
      });
      
      setAskMeVal(response.data);
      setAudioTranscribed(true);
      setMediaRecorder(null);
      
      analytics.trackVoiceEvent('transcription_success', { 
        transcribedLength: response.data?.length || 0 
      });
    } catch (error) {
      setTranscribing(false);
      setIsTyping(false);
      analytics.trackVoiceEvent('transcription_failed', { 
        error: error.response?.data?.error || 'Unknown error' 
      });
      errorSetter(`Transcription failed: ${error.response?.data?.error || 'Try again'}`);
    }
  };

  const handleNewSession = async () => {
    if(!isAuth) {
      // Analytics: Track auth prompt for new session attempt
      holisticAnalytics.track('funnel.login_prompt_shown', { promptedToLogin: true });
      return errorSetter("Log in to access this feature")
    }
    if (messages.length === 0) {
      errorSetter("Already a new session")
    } else {
      // Analytics: Track new session creation
    holisticAnalytics.track('session_created', { featureUsed: 'new_session' });
      
      dispatch(setFetching(true))
      //push a new empty array to backend and frontend
      const emptyArr = []
      try {
        await axios.post("/create-new-askme-session", emptyArr, {
          headers: { "x-access-token": isAuth },
        });
        try {
          const m = await axios.get('/user/messages', { headers: { "x-access-token": isAuth } });
          const arrRaw = Array.isArray(m?.data?.messages) ? m.data.messages : [];
          const meta = m?.data?.threadsMeta || [];
          const arr = arrRaw.map((a,i) => { try { Object.defineProperty(a,'__meta',{ value: meta[i]||{}, enumerable:false}); } catch(_){} return a; });
          dispatch(setAllMessagesArray(arr));
          if (arr.length > 0) dispatch(setMessages(arr[arr.length - 1]));
        } catch(_) {}
        successSetter("New Chat Session Started")
        dispatch(setFetching(false))
        return
      } catch (error) {
        errorSetter(error?.response?.data?.error);
        dispatch(setFetching(false))
      }
    }
  }

  const handleKeyPress = (e) => {
    if (screenWidth > 900 ) {
      if (e.key === "Enter" && !e.shiftKey) { 
        e.preventDefault();
        handleAskMeAnything();
      }
    }
  };


  const handleValChange = (e) => {
    setAskMeVal(e.target.value)
  }

  const location = useLocation();

  const toHomePage = () => {
    // Track input abandonment if user has typed something
    if (askMeVal && askMeVal.trim().length > 0) {
      holisticAnalytics.track('input_abandoned', { messageLength: askMeVal.length, preview: askMeVal.slice(0,50) });
    }
    holisticAnalytics.track('ui.feature_used', { eventData: { action: 'navigation_to_home' } });
    
    const returnTo = location.state?.from || "/";
    navigate(returnTo);
  }

  const handleMenuToggle = () => {
    setAuthMenuOpen(!authMenuOpen)
  }

  const handleFocus = (e) => {
    if (window.innerWidth < 768) {
      setTimeout(() => {
        e.target.scrollIntoView({ block: 'center' });
      }, 300);
    }
  }

  const fileInputRef = useRef(null);

  const handleFileSelect = (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    const maxBytes = 10 * 1024 * 1024;
    let added = 0;
    const newPreviews = [];
    const newFiles = [];
    for (const f of files) {
      if (!f.type.startsWith('image/')) continue;
      if (f.size > maxBytes) { errorSetter('Image larger than 10MB'); continue; }
      if ((imageFiles.length + newFiles.length) >= 5) { errorSetter('Maximum 5 images allowed'); break; }
      const url = URL.createObjectURL(f);
      newPreviews.push(url);
      newFiles.push(f);
      added++;
    }
    if (added > 0) {
      setImagePreviews(prev => [...prev, ...newPreviews].slice(0,5));
      setImageFiles(prev => [...prev, ...newFiles].slice(0,5));
    }
    e.target.value = null;
  }

  const triggerFileSelect = () => {
    if (fileInputRef.current) fileInputRef.current.click();
  }

  const removeSingleImage = (idx) => {
    setImagePreviews(prev => {
      const copy = [...prev];
      const [removed] = copy.splice(idx,1);
      try { if (removed) URL.revokeObjectURL(removed); } catch(_) {}
      return copy;
    });
    setImageFiles(prev => {
      const copy = [...prev];
      copy.splice(idx,1);
      return copy;
    });
  }

  const clearAllImagePreviews = () => {
    imagePreviews.forEach(u => { try { URL.revokeObjectURL(u); } catch(_) {} });
    setImagePreviews([]);
    setImageFiles([]);
  }

  // Replicate services from utils/bubble-services.js for frontend buttons
  const services = [
    { title: 'Resume Creation', link: '/user/dashboard/resume' },
    { title: 'Apply For Me', link: '/user/dashboard/job-hub' },
    { title: 'Job-Connect Me', link: '/user/dashboard/job-hub' },
    { title: 'Cover Letter', link: '/user/dashboard/resume-hub' },
    { title: 'Job Interview Simulation', link: '/user/dashboard/resume-hub' },
    { title: 'Exam Simulation', link: '/user/dashboard/mock' },
    { title: 'General Prompting', link: '/chat' },
    { title: 'Career Roadmap', link: '/user/dashboard/career-roadmap' },
    { title: 'Bubble Ai Schools', link: '/school', className: styles.svcSchools }
  ];

  const openService = (link) => {
    // Analytics: Track service click
    const serviceName = services.find(s => s.link === link)?.title || 'Unknown Service';
    holisticAnalytics.track('service_click', { clickedServiceLink: [serviceName], featureUsed: 'service_redirect' });

    // If user is not authenticated and the target is a /user route, redirect to popin with query
    let target = link;
    const isAuth = localStorage?.getItem('token');
    if (!isAuth && link.startsWith('/user')) {
      const tail = link.split('/').pop();
      target = `/popin?${tail}`;
    }

    // preserve absolute links as-is; otherwise navigate locally
    if (target.startsWith('http')) {
      window.open(target, '_blank');
    } else {
      window.location.href = target;
    }
  }

  return (<>
    <div id="askme-bg" className="askme-bg" onClick={handleFocus}>
        <AuthSideMenu
            opened={authMenuOpen}
            seacrhBarPlaceholder=""
            hidden={!authMenuOpen}
            firstName={user.firstName}
            arrayDetails={allMessagesArray}
            onSwitch={() => setAuthMenuOpen(false)}
        />

        <div className="chat-header" style={{paddingTop: isIOSStandalonePWA() && "50px"}}>

          {/* <AddCircleIcon fontSize='large' sx={{color: "white"}} /> */}
          <div
            className="close-icon"
            title="Close Chat"
            onClick={toHomePage}
            style={{ 
              background: 'rgba(255, 255, 255, 0.05)', 
              borderRadius: '12px', 
              padding: '8px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
              border: '1px solid rgba(255, 255, 255, 0.1)',
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              backdropFilter: 'blur(10px)',
              boxShadow: '0 4px 15px rgba(0,0,0,0.1)'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = 'rgba(239, 83, 80, 0.1)';
              e.currentTarget.style.borderColor = 'rgba(239, 83, 80, 0.4)';
              e.currentTarget.style.transform = 'scale(1.05)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'rgba(255, 255, 255, 0.05)';
              e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.1)';
              e.currentTarget.style.transform = 'scale(1)';
            }}
          >
            <CloseIcon 
              sx={{ fontSize: '20px', color: 'rgba(255, 255, 255, 0.7)' }}
            />
          </div>

          <div 
            title="Start New Session"
            onClick={handleNewSession}
            style={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: '8px', 
              cursor: 'pointer',
              background: 'rgba(62, 143, 147, 0.2)',
              padding: '8px 16px',
              borderRadius: '16px',
              border: '1px solid rgba(62, 143, 147, 0.3)',
              marginLeft: screenWidth > 900 ? '0' : '0',
              flex: '1',
              justifyContent: 'center',
              maxWidth: 'fit-content',
              margin: '0 auto',
              transition: 'all 0.2s ease'
            }}
          >
            <AddIcon sx={{color: "#3E8F93", fontSize: '20px'}} />
            <span style={{ color: '#3E8F93', fontSize: '13px', fontWeight: 700 }}>New Chat</span>
          </div>

          <div 
            className="chat-menu-icon" 
            title="Menu"
            style={{ 
              background: 'rgba(255, 255, 255, 0.05)', 
              borderRadius: '12px', 
              padding: '6px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
              border: '1px solid rgba(255, 255, 255, 0.1)',
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              backdropFilter: 'blur(10px)',
              boxShadow: '0 4px 15px rgba(0,0,0,0.1)'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = 'rgba(62, 143, 147, 0.1)';
              e.currentTarget.style.borderColor = 'rgba(62, 143, 147, 0.4)';
              e.currentTarget.style.transform = 'scale(1.05)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'rgba(255, 255, 255, 0.05)';
              e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.1)';
              e.currentTarget.style.transform = 'scale(1)';
            }}
          >
              {!authMenuOpen ? 
                <BiMenuAltRight size='1.8em' color="rgba(255,255,255,0.8)" onClick={handleMenuToggle} />
              :
                <BiMenuAltLeft size='1.8em' color="rgba(255,255,255,0.8)" onClick={handleMenuToggle} />}
          </div>
        </div>

        {tutorContext && messages.length > 0 && (
          <div style={{
            position: 'fixed',
            top: isIOSStandalonePWA() ? '120px' : '85px',
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: 1000,
            padding: '8px 20px',
            background: 'rgba(12, 30, 40, 0.8)',
            backdropFilter: 'blur(15px)',
            border: '1px solid rgba(62, 143, 147, 0.3)',
            borderRadius: '30px',
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
            animation: 'fadeInDown 0.5s ease-out'
          }}>
            <FaRobot color="#3E8F93" size={16} />
            <span style={{ fontSize: '12px', color: '#fff', fontWeight: 600, letterSpacing: '0.5px' }}>
              AI TUTOR MODE: <span style={{ color: '#3E8F93' }}>{tutorContext.examName}</span>
            </span>
            <div 
              onClick={handleCancelTutor}
              style={{ 
                display: 'flex', 
                alignItems: 'center', 
                cursor: 'pointer',
                padding: '4px',
                borderRadius: '50%',
                transition: 'all 0.2s'
              }}
              onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(239, 83, 80, 0.15)'}
              onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
            >
              <CancelIcon sx={{ color: 'rgba(255,255,255,0.6)', fontSize: '20px', '&:hover': { color: '#ef5350' } }} />
            </div>
          </div>
        )}
       

        <div className="chatbg-overlay" onClick={() => setAuthMenuOpen(false)}>
            <div className="chat-ex" ref={chatBoxRef} onScroll={handleScroll} style={{ paddingBottom: '140px' }}>
              {isLoadingMore && (
                <ThinkingContainer style={{ justifyContent: 'center', width: '100%', marginBottom: '20px' }}>
                  <ThinkingText>Loading History</ThinkingText>
                  <div style={{ display: 'flex', gap: '4px' }}>
                    <Dot />
                    <Dot />
                    <Dot />
                  </div>
                </ThinkingContainer>
              )}

              {interviewLoading && messages.length <= 1 ? (
                <div className={`${styles.loaderWrap} ${interviewLoading ? styles.loaderShow : styles.loaderHide}`}>
                  <Vortex
                    visible={true}
                    height={220}
                    width={220}
                    ariaLabel="interview-loading"
                    colors={["#3E8F93", "#0d3d40", "#3E8F93", "#0d3d40", "#3E8F93", "#0d3d40"]}
                  />
                  <h3 style={{color:'#fff', textAlign:'center', maxWidth:'420px', lineHeight:'1.4'}}>
                    Simulating Possible Interview Questions and Real Answers...
                  </h3>
                </div>
              ) : Array.isArray(messages) && messages.length === 0 ? (
                  <div className={styles.emptyServices}>
                    {tutorContext ? (
                      <div style={{ textAlign: 'center', animation: 'fadeIn 0.8s ease-out' }}>
                        <div style={{ marginBottom: '1.5rem', display: 'flex', justifyContent: 'center' }}>
                          <div style={{ position: 'relative' }}>
                            <FaRobot size={60} color="#3E8F93" />
                            <div style={{ position: 'absolute', bottom: -5, right: -5, background: '#3E8F93', borderRadius: '50%', padding: '4px', border: '2px solid #0C1E28' }}>
                              <FaBolt size={12} color="#fff" />
                            </div>
                          </div>
                        </div>
                        <h2 style={{ color: '#fff', marginBottom: '0.5rem', fontWeight: 800 }}>AI Tutor Mode Active</h2>
                        <p style={{ color: 'rgba(255,255,255,0.7)', maxWidth: '400px', margin: '0 auto 2rem auto', fontSize: '0.95rem' }}>
                          I am ready to help you master <span style={{ color: '#3E8F93', fontWeight: 700 }}>{tutorContext.examName}</span>. Ask me anything about your results, mistakes, or concepts you didn't understand.
                        </p>
                        <div style={{ 
                          padding: '12px 24px', 
                          background: 'rgba(62, 143, 147, 0.05)', 
                          borderRadius: '20px', 
                          border: '1px solid rgba(62, 143, 147, 0.1)', 
                          display: 'inline-flex', 
                          alignItems: 'center', 
                          gap: '12px',
                          transition: 'all 0.3s ease'
                        }}>
                          <div style={{ width: 8, height: 8, borderRadius: '50%', background: '#3E8F93', boxShadow: '0 0 10px #3E8F93' }} />
                          <span style={{ fontSize: '0.8rem', color: 'rgba(255,255,255,0.6)', fontWeight: 500 }}>
                            Bubble RA-1 Engine Tuned for <span style={{ color: '#3E8F93', fontWeight: 700 }}>{tutorContext.examName}</span>
                          </span>
                          <div 
                            onClick={handleCancelTutor}
                            style={{ 
                              display: 'flex', 
                              alignItems: 'center', 
                              cursor: 'pointer',
                              padding: '2px',
                              marginLeft: '8px',
                              borderRadius: '50%',
                              transition: 'background 0.2s'
                            }}
                            onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(239, 83, 80, 0.1)'}
                            onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
                          >
                            <CancelIcon sx={{ color: 'rgba(255,255,255,0.4)', fontSize: '18px', '&:hover': { color: '#ef5350' } }} />
                          </div>
                        </div>
                      </div>
                    ) : (
                      <>
                        <div className={styles.emptyIntro}>
                          <h2>Hi — I’m Bubble Ai</h2>
                          <p>Your career assistant. Ask me to build resumes, apply to jobs, prepare interviews, simulate exams, or just chat.</p>
                        </div>
                        <div className={styles.emptyActions}>
                          {services.map((svc, idx) => (
                                <button
                                  key={idx}
                                  className={`${styles.svcItem} ${svc.className || styles['svc' + idx] || ''}`}
                                  onClick={() => openService(svc.link)}
                                >
                                  {svc.title}
                                </button>
                              ))}
                        </div>
                      </>
                    )}
                  </div>
                ) : (
                  chatExchange
                )}
              
              <ScrollToBottom 
                onClick={scrollToBottom} 
                visible={showScrollButton} 
              />
            </div>

            <div className="ask-me-form">

              <Grid container sx={{ position: 'relative' }}>
                {recording ? (
                  <Grid container>
                    <Grid item xs={10} sx={{ display: 'flex', justifyContent: 'center', height: "100px" }}>
                      {renderLineWaves()} 
                    </Grid>
                    <Grid item xs={2} sx={{ display: 'flex', justifyContent: 'center' }}>
                      <StopIcon sx={{ color: 'rgb(216, 7, 7)', fontSize: '2.2em', cursor: 'pointer'}} onClick={handleRecordAudio} />
                    </Grid>
                  </Grid>

                ) : audioBlob ? (
                  <Grid container>
                    <Grid item xs={10}>
                      <audio controls style={{ width: "100%", marginTop: screenWidth > 900 ? '15px' : "5px", marginLeft: '10px' }}>
                        <source src={URL.createObjectURL(audioBlob)} type="audio/mp3" style={{ height: "50px" }} />
                      </audio>
                    </Grid>
                    <Grid item xs={2}>
                      <ButtonSubmitBlack onClick={handleSendAudio}>
                        <GrSend style={{ color: "#3E8F93", fontSize: '2.2em', cursor: 'pointer' }} />
                      </ButtonSubmitBlack>
                      <ButtonSubmitBlack onClick={() => setAudioBlob(null)}>
                        <CancelIcon sx={{ color: "rgb(216, 7, 7)", fontSize: '1.8em', cursor: 'pointer' }} />
                      </ButtonSubmitBlack>
                    </Grid>
                  </Grid>
                ) : (
                  <div className={styles.composerWrap}>
                    <div className={styles.composerInner}>
                      {/* Image preview above the input without pushing it off-screen */}
                      {imagePreviews.length > 0 && (
                        <div className={`${styles.imagePreviewWrap} ${inputFocused ? styles.focusedWrap : ''}`}>
                          <div className={styles.multiPreviewGrid}>
                            {imagePreviews.map((src, idx) => (
                              <div key={idx} className={styles.imagePreviewInner}>
                                <img
                                  src={src}
                                  alt={`preview-${idx}`}
                                  className={`${styles.imagePreviewImg} ${inputFocused ? styles.focusedImg : ''}`}
                                />
                                <button onClick={() => removeSingleImage(idx)} title="Remove image" className={styles.imagePreviewCancel}>
                                  <CancelIcon sx={{ fontSize: '16px' }} />
                                </button>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}

                      <AuthInput
                        id="askMe"
                        name="askMe"
                        value={askMeVal}
                        label="Ask a Question..."
                        placeholder="Ask a Question..."
                        multiline={true}
                        inputGridSm={12}
                        buttonInInput={true}
                        mt={1}
                        rows={2}
                        mb={1}
                        maxRows={4}
                        required={true}
                        onKeyDown={handleKeyPress}
                        onChange={handleValChange}
                      />
                      <div className={`${styles.askmeControls}`}>
                        {/* Upload button + send/record buttons */}
                        <input
                          ref={fileInputRef}
                          type="file"
                          accept="image/*"
                          multiple
                          onChange={handleFileSelect}
                          className={styles.hiddenFileInput}
                        />
                        <div className={styles.leftControls}>
                          <div className={styles.uploadBtn}>
                              <button onClick={triggerFileSelect} title="Upload image or paste" className={uploadBtnStyles.uploadPasteBtn}>
                              <TbScreenshot style={{ color: '#fff', fontSize: '1.1rem' }} />
                                <span className={uploadBtnStyles.uploadPasteBtnText}>Upload/Paste</span>
                            </button>
                          </div>
                        </div>

                        <div className={styles.rightControls}>
                          {askMeVal ? (
                            <ButtonTransparentSquare 
                              type="button" 
                              onClick={handleAskMeAnything}
                              color=""
                              width="40px"
                              height="40px"
                              bgColor="black"
                              borderRadius="50%"
                            >
                              <GrSend style={{ color: "#3E8F93", fontSize: '1.8em' }} />
                            </ButtonTransparentSquare>
                          ) : (
                            <ButtonTransparentSquare 
                              type="button" 
                              onClick={handleRecordAudio}
                              color=""
                              width="40px"
                              height="40px"
                              bgColor="black"
                              borderRadius="50%"
                            >
                              {transcribing ? (
                                <Oval
                                  visible={true}
                                  height="30px"
                                  width="30px"
                                  color="#3E8F93"
                                  ariaLabel="oval-loading"
                                />
                              ) : (
                                <MicIcon sx={{ fontSize: '2em', color: '#3E8F93' }} />
                              )}
                            </ButtonTransparentSquare>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </Grid>
            </div>
        </div>
    </div>
    {askPricingOpen && (
      <ResumePricing closePricing={() => {
        analytics.trackPricingView();
        setAskPricingOpen(false);
      }} open={askPricingOpen} />
    )}
  </>);
};

export default AskMe;
